import script from "./NewUser.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUser.vue?vue&type=script&setup=true&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=1630a398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1630a398"]])

export default __exports__